import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'providers',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class Providers extends Vue {

    // -------------------------------------------------------------------
    // Properties

    @Prop()
    private cardName!: string;

    @Prop()
    private providerList: any;

    private defaultSelected: any = 'google';

    private selectedKey: any = this.defaultSelected;

    // -----------------------------------------------------------------------
    // Actions

    private onGoNext() {
        this.$emit('onGoNext' , this.selectedKey);
    }

}
